"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file @preserve */ /**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */ const defaultTranslations = exports.defaultTranslations = {
    categories: 'Categories',
    inspirationCorner: 'Inspiration corner',
    loadMore: 'Load more',
    otherCategories: 'Other categories',
    readNow: 'Read now',
    relatedArticles: 'Related articles',
    showingXOutOfYProducts: 'Showing {value} out of {max} articles',
    view: 'View',
    whatsNew: "What's new"
};
const translationsNamespace = exports.translationsNamespace = 'products_editorial-category';
